import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { hydrate, render } from "react-dom";
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider as StyletronProvider, DebugEngine } from "styletron-react";
import { Client as Styletron } from "styletron-engine-atomic";
// import TagManager from 'react-gtm-module'
import ReactGA from 'react-ga';
ReactGA.initialize('UA-1869497-109');

// TagManager.initialize(tagManagerArgs);

const debug = process.env.NODE_ENV === "production" ? void 0 : new DebugEngine();

// 1. Create a client engine instance
const engine = new Styletron();

const rootElement = document.getElementById("root");

// if (rootElement.hasChildNodes()) {
//   hydrate(
//     <StyletronProvider value={engine} debug={debug} debugAfterHydration>
//       <App />
//     </StyletronProvider>, rootElement);
// } else {
//   render(
//     <StyletronProvider value={engine} debug={debug} debugAfterHydration>
//       <App />
//     </StyletronProvider>, rootElement);
// }

render(
  <StyletronProvider value={engine} debug={debug} debugAfterHydration>
    <App />
  </StyletronProvider>
  , rootElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
